// Fotos de paquetes, de entregas y de la persona: se reducen en el celular antes de subirlas (datos móviles).

import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { idAleatorio } from "./datos";
import { almacen } from "./firebase";

async function reducir(archivo: File, ladoMaximo = 1280, calidad = 0.75, tipo = "image/jpeg"): Promise<Blob> {
  const imagen = await createImageBitmap(archivo).catch(() => null);
  if (!imagen) return archivo;
  const escala = Math.min(1, ladoMaximo / Math.max(imagen.width, imagen.height));
  const lienzo = document.createElement("canvas");
  lienzo.width = Math.round(imagen.width * escala);
  lienzo.height = Math.round(imagen.height * escala);
  lienzo.getContext("2d")!.drawImage(imagen, 0, 0, lienzo.width, lienzo.height);
  return new Promise((resolver) => lienzo.toBlob((b) => resolver(b ?? archivo), tipo, calidad));
}

/** Sube la foto a conjuntos/{cid}/fotos/ y devuelve la URL de descarga. */
export async function subirFoto(conjuntoId: string, archivo: File): Promise<string> {
  const blob = await reducir(archivo);
  const destino = ref(almacen, `conjuntos/${conjuntoId}/fotos/${idAleatorio()}.jpg`);
  await uploadBytes(destino, blob, { contentType: "image/jpeg" });
  return getDownloadURL(destino);
}

/**
 * Foto de la persona (el vigilante la compara con la cara del domiciliario): la sube a
 * usuarios/{uid}/foto-{uuid}.jpg y devuelve la URL de descarga. Después hay que llamar `actualizarFoto`.
 */
export async function subirFotoPerfil(uid: string, archivo: File): Promise<string> {
  const blob = await reducir(archivo, 720, 0.8);
  const destino = ref(almacen, `usuarios/${uid}/foto-${idAleatorio()}.jpg`);
  await uploadBytes(destino, blob, { contentType: "image/jpeg" });
  return getDownloadURL(destino);
}

/**
 * Logo del conjunto: se guarda en PNG para no perder el fondo transparente, a 512 px como máximo. Lo sube a
 * conjuntos/{cid}/logo/{uuid}.png y devuelve la URL de descarga. Después hay que llamar `adminCambiarLogo`.
 */
export async function subirLogo(conjuntoId: string, archivo: File): Promise<string> {
  const blob = await reducir(archivo, 512, 0.92, "image/png");
  const destino = ref(almacen, `conjuntos/${conjuntoId}/logo/${idAleatorio()}.png`);
  await uploadBytes(destino, blob, { contentType: blob.type || "image/png" });
  return getDownloadURL(destino);
}

/**
 * Foto del vigilante o domiciliario cuya cuenta crea la administración: la sube a conjuntos/{cid}/personal/{uuid}.jpg
 * y devuelve la URL de descarga, que va en `adminCrearPersonal`.
 */
export async function subirFotoPersonal(conjuntoId: string, archivo: File): Promise<string> {
  const blob = await reducir(archivo, 720, 0.8);
  const destino = ref(almacen, `conjuntos/${conjuntoId}/personal/${idAleatorio()}.jpg`);
  await uploadBytes(destino, blob, { contentType: "image/jpeg" });
  return getDownloadURL(destino);
}
